import React, { useState, useCallback } from "react";
import "./styles.css";

const dataCenters = [
  {
    id: 1,
    name: "Toronto Area",
    x: 600,
    y: 500,
    capacity: "500 nodes available",
    power: "5 MW",
  },
  {
    id: 2,
    name: "Vancouver Area",
    x: 100,
    y: 375,
    capacity: "800 nodes available",
    power: "3 MW",
  },
  {
    id: 3,
    name: "Montreal Area",
    x: 715,
    y: 475,
    capacity: "1000 nodes available",
    power: "1 MW",
  },
  {
    id: 4,
    name: "Quebec Area",
    x: 775,
    y: 440,
    capacity: "500 nodes available",
    power: "6 MW",
  },
  {
    id: 5,
    name: "Calgary Area",
    x: 250,
    y: 375,
    capacity: "1000 nodes available",
    power: "4 MW",
  },
  {
    id: 6,
    name: "Trois-Rivières Area",
    x: 750,
    y: 465,
    capacity: "2000 nodes available",
    power: "15 MW",
  },
];

const Marker = ({ onMouseEnter, onMouseLeave, isSelected, id }) => {
  return (
    <svg
      width="56"
      height="71"
      viewBox="0 0 56 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className="marker"
    >
      {isSelected ? (
        <>
          <circle cx="28.5" cy="28.5" r="12.5" fill="white" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M56 28C56 39.2681 49.3439 48.9816 39.749 53.4232C39.3601 53.6032 39.031 53.8937 38.8168 54.2648L29.7321 70C28.9622 71.3333 27.0377 71.3333 26.2679 70L17.1833 54.2648C16.969 53.8937 16.6399 53.6032 16.251 53.4232C6.65608 48.9816 0 39.2681 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28ZM28 37C32.9706 37 37 32.9706 37 28C37 23.0294 32.9706 19 28 19C23.0294 19 19 23.0294 19 28C19 32.9706 23.0294 37 28 37Z"
            fill="url(#paint0_linear_1256_172)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1256_172"
              x1="28"
              y1="0"
              x2="28"
              y2="71.0001"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#C8FC3C" />
              <stop offset="1" stopColor="#379254" />
            </linearGradient>
          </defs>
        </>
      ) : (
        <>
          <circle cx="28.5" cy="28.5" r="12.5" fill="#11192A" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M56 28C56 39.2681 49.3439 48.9816 39.749 53.4232C39.3601 53.6032 39.031 53.8937 38.8168 54.2648L29.7321 70C28.9622 71.3333 27.0377 71.3333 26.2679 70L17.1833 54.2648C16.969 53.8937 16.6399 53.6032 16.251 53.4232C6.65608 48.9816 0 39.2681 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28ZM28 37C32.9706 37 37 32.9706 37 28C37 23.0294 32.9706 19 28 19C23.0294 19 19 23.0294 19 28C19 32.9706 23.0294 37 28 37Z"
            fill="url(#paint0_linear_1259_185)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1259_185"
              x1="28"
              y1="0"
              x2="28"
              y2="71.0001"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#3D4F1E" />
              <stop offset="1" stopColor="#183325" />
            </linearGradient>
          </defs>
        </>
      )}
    </svg>
  );
};

const CanadaMap = ({
  onMouseEnterMarker,
  onMouseLeaveMarker,
  selectedMarker,
}) => (
  <svg
    width="926"
    height="609"
    viewBox="0 0 926 609"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: "100%", height: "auto", backgroundColor: "transparent" }}
  >
    <path
      d="M132 32L112.5 3L44 95L2 156.5L44 199V233L36 279.5V350.5L44 416.5L82.5 463H119.5L212.5 495.5H279.5L374 511L429 495.5L517.5 511L538 485L565.5 495.5L595.5 523L620.5 530L645 546.5L652 604L669.5 572.5L723 546.5L792.5 485L803.5 449L838 474H892.5L924 394.5L906.5 385L866.5 416.5L838 401.5L792.5 416.5V401.5L820 359L866.5 331.5L881.5 285L892.5 260.5L838 233H780.5L713.5 178V220.5L690 233L661.5 199L620.5 188L574 199L591.5 233L595.5 279.5L634 319L620.5 350.5L634 385L620.5 416.5L591.5 350.5L553.5 359L500 338.5L457.5 319L439.5 285V248L472.5 199L500 149.5L429 166L279.5 122L242.5 74.5L200 44L132 32Z"
      stroke="#F7FAE5"
      strokeWidth="3"
      fill="transparent"
    />
    {dataCenters.map((dc) => (
      <g key={dc.id} transform={`translate(${dc.x - 28}, ${dc.y - 71})`}>
        <Marker
          id={dc.id}
          onMouseEnter={() => onMouseEnterMarker(dc)}
          onMouseLeave={onMouseLeaveMarker}
          isSelected={selectedMarker?.id === dc.id}
        />
      </g>
    ))}
  </svg>
);

const InfoBlock = ({ dataCenter }) => (
  <div className="info-block">
    <div className="name">{dataCenter.name}</div>
    <div className="power">{dataCenter.power}</div>
    <div className="locations">4 Locations Available</div>
    <div className="capacity">{dataCenter.capacity}</div>
  </div>
);

const App = () => {
  const [selectedMarker, setSelectedMarker] = useState(null);

  const handleMouseEnterMarker = useCallback((dataCenter) => {
    setSelectedMarker(dataCenter);
  }, []);

  const handleMouseLeaveMarker = useCallback(() => {
    setSelectedMarker(null);
  }, []);

  return (
    <div id="app-container">
      <div id="map-container">
        <CanadaMap
          onMouseEnterMarker={handleMouseEnterMarker}
          onMouseLeaveMarker={handleMouseLeaveMarker}
          selectedMarker={selectedMarker}
        />
      </div>
      <div
        className={`info-block-container ${selectedMarker ? "visible" : ""}`}
      >
        {selectedMarker && <InfoBlock dataCenter={selectedMarker} />}
      </div>
    </div>
  );
};

export default App;
